import React, { Component } from 'react';
import StockList from './list/StockList';
import { CardLayout } from './containers/Layout';
import CardPage from '../../../commonModules/layouts/CardPage';


class Stocks extends Component{
    state = { }
    render(){        
        return(
            <CardPage title="Inventaire"  storehouse>
                <StockList history {...this.props}/>
            </CardPage>
        )
    }
}

export default Stocks